import React, { type ReactNode, forwardRef } from "react";

import clsx from "clsx";

import { Button, type ButtonProps } from "./button";

export interface IconButtonProps extends ButtonProps {
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ children, leftIcon, rightIcon, ...props }, ref) => (
    <Button
      {...props}
      ref={ref}
      className={clsx("icon-button", props.className)}
    >
      {leftIcon && <span className="mr-1">{leftIcon}</span>}
      {children}
      {rightIcon && <span className="ml-1">{rightIcon}</span>}
    </Button>
  ),
);
